import CustomCardHeader from "../../components/card/CustomCardHeader";
import {SemiTransparentButton} from "../../components/CustomButton";
import CardBody from "../../components/card/CardBody";
import CustomTable from "../../components/table/CustomTable";
import CustomCard from "../../components/card/CustomCard";
import ManageUserTable from "./components/ManageUserTable";
import ManageUserFormModal from "./components/ManageUserFormModal";
import {
  resetManageUsers,
  setAdminsTableMode,
  setManageUserModals,
  setSelectedTab
} from "../../redux/slices/manageUserSlice";
import {useDispatch, useSelector} from "react-redux";
import UsersPaginator from "./components/UsersPaginator";
import {ADMIN_USERS, NORMAL_USERS, TABLE_DISPLAY_MODE_FEATURES} from "./constants";
import ManageUserTableHeader from "./components/ManageUserTableHeader";
import ManageUserConfirmModal from "./components/ManageUserConfirmModal";
import AddFeaturesModal from "./components/AddFeaturesModal";
import {useEffect} from "react";
import {getFullName} from "../../helpers/helperFunctions";
import ChipGroup, {ChipSecondary} from "../../components/Chips";

export default function UserProfile() {

  const dispatch = useDispatch();

  const user = useSelector((state) => state.authToken.user);

  useEffect(() => {

    return () => {
      // dispatch(resetManageUsers())
    };
  }, []);

  return (
    <>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <CustomCard>
              <CustomCardHeader color="blue" contentPosition="none">
                <div className="flex items-center justify-between w-full">
                  <h2 className="text-2xl text-white">Profile</h2>
                  <div className="flex space-x-2">
                    <SemiTransparentButton onClick={() => dispatch(setManageUserModals({
                      modal: true,
                      data: user,
                      ext: {fromProfile: true}
                    }))}>
                      Edit
                    </SemiTransparentButton>
                  </div>

                </div>
              </CustomCardHeader>
              <CardBody>
                <div className="custom-card">
                  <div className="flex mb-3">
                    <div className="w-44 font-medium">Name:</div>
                    <div className="flex-1">{getFullName(user)}</div>
                  </div>
                  <div className="flex mb-3">
                    <div className="w-44 font-medium">Role:</div>
                    <div className="flex-1">{user.super_admin ? "Super admin" : user.staff ? "Admin" : "Normal Admin"}</div>
                  </div>
                  <div className="flex">
                    <div className="w-44 font-medium">Access:</div>
                    <div className="flex-1"><ChipGroup>
                      {
                        user.super_admin || user.staff ? <ChipSecondary label="All"/> :


                          !user.features.length ? <ChipSecondary label="No Access"/> :

                          user.features.map((f) => <ChipSecondary label={f.name} key={f.id}/>)
                      }

                    </ChipGroup></div>
                  </div>


                </div>
              </CardBody>
            </CustomCard>
            <ManageUserFormModal/>
          </div>
        </div>
      </div>
    </>
  );
}

